import { ReactNode } from "react";
import { cn } from "@/utils/tailwind";
import {
  ResponsiveModalContent,
  ResponsiveModalDescription,
  ResponsiveModalTitle,
} from "@/kit/ui/responsive-modal";

interface BrandModalContentProps {
  icon: ReactNode;
  title: ReactNode;
  description: ReactNode;
  children: ReactNode;
  className?: string;
}

/// The gradient shell with a centered brand icon, title and description shared
/// by the workspace create + clone dialogs. `children` (the form) renders below
/// the header, inside the same centered column.
export default function BrandModalContent({
  icon,
  title,
  description,
  children,
  className,
}: BrandModalContentProps) {
  return (
    <ResponsiveModalContent
      className={cn(
        "lg:w-150 px-4 bg-linear-to-b from-brand-25 from-[-16.39%] to-white to-[65.62%] rounded-xl",
        className,
      )}
    >
      <div className="flex flex-col items-center justify-center gap-3 mb-4">
        <div className="flex items-center justify-center bg-brand-50 rounded-lg backdrop-blur-sm overflow-hidden w-14 h-14">
          {icon}
        </div>
        <ResponsiveModalTitle className="text-center text-2xl font-semibold text-grey-900">
          {title}
        </ResponsiveModalTitle>
        <ResponsiveModalDescription className="text-center text-sm font-normal text-grey-600 leading-tight">
          {description}
        </ResponsiveModalDescription>
        {children}
      </div>
    </ResponsiveModalContent>
  );
}
